export type { Discriminant } from './discriminant';
export { discriminant } from './discriminant';
export type {
    inferParsedDiscriminant,
    inferParsedUnion,
    inferRawDiscriminant,
    inferRawUnion,
    UnionSubtypes,
} from './types';
export { union } from './union';
